import React from "react";
import { Formik, Form, Field } from "formik";
import { Row, Col } from "reactstrap";
import { Button } from "zina-dogi-react";
import AsyncSelect from "react-select/async";
import { service as activityService } from "../redux";
import {  useHeaderTitle } from "~/utils";

const filterValCustomerTeam = (val) => {
    return activityService
        .getActivityCustomerTeams(val)
        .then(resp =>
            resp.map(val => {
                return {
                    value: val.id,
                    label: val.name
                };
            })
        );
};

const ActivityFilter = ({ className, onSubmit = () => {}, ...props }) => {
    const comp_op = {
        className: ["activity_filters", className].join(" ")
    };

    useHeaderTitle(props.setheader, "Activity Management");

    return (
        <div {...comp_op}>
            <div className="content">
                <Formik
                    initialValues={{
                        customer_team: null,
                        activity_name: null,
                        smp_name: null,
                    }}
                    enableReinitialize={true}
                    onSubmit={(values, cmp) => handleSubmit(onSubmit, values, cmp)}
                    onReset={(values, {resetForm, submitForm}) => {
                        resetForm()
                        submitForm()
                    }}
                >
                    {props => {
                        const { values, setFieldValue } = props;
                        return (
                            <Form>
                                <Row>
                                    <Col sm="12" md="4">
                                        <div className="form-group">
                                            <label>Customer Team</label>
                                            <Field
                                                name="customer_team"
                                                value={values.customer_team}
                                                component={AsyncSelect}
                                                isClearable
                                                cacheOptions
                                                defaultOptions
                                                loadOptions={val => filterValCustomerTeam(val)}
                                                onChange={val => setFieldValue("customer_team", val, false)}
                                            />
                                        </div>
                                    </Col>
                                    <Col sm="12" md="4">
                                        <div className="form-group">
                                            <label>Activity Name</label>
                                            <Field
                                                title="Activity Name"
                                                name="activity_name"
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </Col>
                                    <Col sm="12" md="4">
                                        <div className="form-group">
                                            <label>Smp Name</label>
                                            <Field
                                                title="Smp Name"
                                                name="smp_name"
                                                type="text"
                                                className="form-control"
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="controls">
                                    <Button type="reset" color="danger" icon="sync-alt">
                                        Clear filters
                                    </Button>
                                    <Button type="submit" color="primary" icon="filter">
                                        Filter
                                    </Button>
                                </Row>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </div>
    );
};

const handleSubmit = (submit, obj, { setSubmitting }) => {
    console.log(obj)
    submit({
        ...(obj.customer_team ? { customer_team: obj.customer_team.value } : {}),
        ...(obj.activity_name ? { activity_name: obj.activity_name }: {}),
        ...(obj.smp_name      ? { smp_name: obj.smp_name }: {}),
    });
    setSubmitting(false);
};

export default ActivityFilter;
